import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box, TextField } from '@mui/material';
import { IoClose } from "react-icons/io5";

export default function ConfirmationDialog(props) {
  

  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
       
        <DialogContent>
        <Box sx={{ position: 'absolute', top: 5, right: 5, cursor: 'pointer', fontSize: '20px' }} onClick={props.handleClose}>
                        <IoClose />
                    </Box>
        <TextField 
        id="outlined-basic" 
        label="Remarks"
        fullWidth
        size='small'
        value={props.remarks}
        onChange={(e)=>props.handleChange(e)}
        variant="outlined" />

        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
          <Button disabled={props.IsLoading} size='small' variant='contained' color='secondary' onClick={props.handleSubmit}>
            {props.IsLoading?"Loading...":"Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
